import { Component } from '@angular/core';

@Component({
  selector: 'ui-panel-footer',
  templateUrl: './panel-footer.component.html'
})
export class PanelFooterComponent {

}